export interface ReportListItem {
  surveyId: string;
  surveyName: string;
  lastUpdated: Date;
  viewLink: string;
  downloadLink: string;
  hasReport: boolean;
  IsReportInProgress: boolean;
  busy: boolean;
}
